export default __webpack_public_path__ + "static/media/p2023-49.bd92c741.jpeg";